import { SET_REPORT_DATA_STATUS } from './actionTypes';

const setReportDataStatus = status => ({
    type: SET_REPORT_DATA_STATUS,
    payload: status,
});

export default setReportDataStatus;
